module.exports = __webpack_public_path__ + "static/media/What'sAppWeb.101c5129.png";